import React from "react";
import "./Skill.css";
import ComputerIcon from "@material-ui/icons/Computer";

function Skill() {
  return (
    <div className="skills">
      <div className="skills__header" data-aos="fade-right">
        <ComputerIcon className="skills__icon" />
        <h1>My Skills</h1>
      </div>
      <div className="skills__container">
        <ul>
          <div data-aos="fade-right">
            <li className="html">HTML</li>
            <li className="css">CSS</li>
            <li className="js">JS</li>
            <li className="python">PYTHON</li>
            <li className="react">REACT</li>
            <li className="js">jQuery</li>
          </div>
          <div data-aos="fade-left">
            <li className="bootstrap">BOOTSTRAP</li>
           
            <li className="firebase">FIREBASE</li>
          </div>
        </ul>
      </div>
    </div>
  );
}

export default Skill;
